import { createContext, useContext, useState, ReactNode } from "react"
import ProcessModal from "../components/global/ProcessModal"

interface ProcessContextType {
   startProcess: (process: () => Promise<void>) => void
}

const ProcessContext = createContext<ProcessContextType | null>(null)

export function ProcessProvider({ children }: { children: ReactNode }) {
   const [isProcessing, setIsProcessing] = useState(false)
   const [currentProcess, setCurrentProcess] = useState<(() => Promise<void>) | null>(null)

   const startProcess = (process: () => Promise<void>) => {
      setCurrentProcess(() => process)
      setIsProcessing(true)
   }

   const handleClose = () => {
      setIsProcessing(false)
      setCurrentProcess(null)
   }

   return (
      <ProcessContext.Provider value={{ startProcess }}>
         {children}
         {currentProcess && (
            <ProcessModal isOpen={isProcessing} onClose={handleClose} onProcess={currentProcess} />
         )}
      </ProcessContext.Provider>
   )
}

export function useProcess() {
   const context = useContext(ProcessContext)
   if (!context) {
      throw new Error("useProcess must be used within a ProcessProvider")
   }
   return context
}
